import { ResponseCigo, RequestCigo } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { CigoActions } from '../actions';
import { CIGOTypes } from '../../shared/enums';

export interface CigoState {
    response: ResponseCigo;
    request: RequestCigo;
    error: any;
}

export const CigoInitialState: CigoState = {
    response: null,
    request: null,
    error: null
};

const _cigoReducer = createReducer(
    CigoInitialState,

    on(CigoActions.getCigo, (state) => ({
        ...state,
        request: null,
        error: null
    })),

    on(CigoActions.getCigoSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(CigoActions.getCigoError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(CigoActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function cigoReducer(state, action) {
    if (action.type === CIGOTypes.CIGO) {
        state = undefined;
    }
    return _cigoReducer(state, action);
}
